import DataTypes from "+/Engine/Helpers/DataTypes";

const TRANSFORM_INPUT = Symbol("Transformer.transformInput");

export { TRANSFORM_INPUT };

export default class Transformer {

  // -------------------- //
  // Static Class Vars    //
  // -------------------- //

  static #registry = {};

  // --------------------- //
  // Public Static Methods //
  // --------------------- //

  static register(type, TransformerClass) {
    DataTypes.assertString(type);
    if (Transformer.#registry[type]) {
      throw new Error(`Transformer type "${type}" is already registered`);
    }
    Transformer.#registry[type] = TransformerClass;
  }

  static get(type) {
    DataTypes.assertString(type);
    const TransformerClass = Transformer.#registry[type];
    if (!TransformerClass) {
      throw new Error(`unknown transformer type "${type}"`);
    }
    return new TransformerClass();
  }

  // ----------------------- //
  // Public Instance Methods //
  // ----------------------- //

  transform(value, params) {
    this.assertValidInput(value, params);
    return this[TRANSFORM_INPUT](value, params);
  }

  // eslint-disable-next-line no-unused-vars
  assertValidInput(_value, _params) {
    throw new Error(`Transformer "${this.constructor.name}" must implement assertValidInput()`);
  }

  // eslint-disable-next-line no-unused-vars
  [TRANSFORM_INPUT](_value, _params) {
    throw new Error(`Transformer "${this.constructor.name}" must implement [TRANSFORM_INPUT]()`);
  }
}
